import React from "react";
import { Link } from "react-router-dom";
import { PROFILE, ARTSY_NAV_LINKS as NAV_LINKS } from "../data/content";
import { Star } from "./Scribbles";

export const Footer = () => {
  return (
    <footer
      className="border-t-2 border-ink bg-sand-deep px-5 md:px-10 py-12"
      data-testid="site-footer"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
        <div>
          <div className="flex items-center gap-3">
            <h2 className="font-serif text-4xl md:text-5xl text-ink">{PROFILE.name}</h2>
            <Star size={28} />
          </div>
          <p className="font-handwritten text-2xl text-terracotta mt-1">
            {PROFILE.location}
          </p>
        </div>

        <div className="flex flex-wrap gap-x-6 gap-y-2">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="draw-link text-xs uppercase tracking-widest text-ink"
              data-testid={`footer-link-${link.label.toLowerCase()}`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-ink/20 flex flex-col md:flex-row justify-between gap-2 text-xs uppercase tracking-widest text-ink/60">
        <span>© {new Date().getFullYear()} {PROFILE.name}. Made by hand.</span>
        <a
          href={`mailto:${PROFILE.email}`}
          className="draw-link"
          data-testid="footer-email"
        >
          {PROFILE.email}
        </a>
      </div>
    </footer>
  );
};
